import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh', p: 2 }}>
      <Stack alignItems="center" spacing={1.5} textAlign="center" sx={{ maxWidth: 420 }}>
        <Typography variant="h1" fontWeight={800} color="primary" sx={{ fontSize: { xs: '3.5rem', sm: '4.5rem' }, lineHeight: 1 }}>
          404
        </Typography>
        <Typography variant="h5">Page not found</Typography>
        <Typography variant="body2" color="text.secondary">
          The page you're looking for doesn't exist or has moved.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard')} sx={{ mt: 1 }}>
          Go home
        </Button>
      </Stack>
    </Box>
  );
}
